<template>
    <v-autocomplete :value="value" :items="processes" item-value="id" item-text="name" :loading="loading" dense outlined hide-details
        placeholder="Selecione o processo" no-data-text="Nenhum processo cadastrado" prepend-inner-icon="mdi-bank-outline"
        :menu-props="{ offsetY: true }" aria-label="Processo competitivo" class="cp-picker" @change="select">
        <template v-slot:item="{ item }">
            <div class="py-1">
                <div class="ui-cell-main">{{ item.name }}</div>
                <div class="ui-cell-sub">/{{ item.slug }}<span v-if="item.client"> · {{ item.client.name }}</span></div>
            </div>
        </template>
    </v-autocomplete>
</template>

<script>
import axios from "axios";
import { API, notifyError, rememberProcess, rememberedProcess } from "./competitive.util";

// Seletor do processo nas telas de Ativos, Cestas e lotes, Etapas e Painel. Sem
// processo na URL, abre no ultimo usado (ou no primeiro da lista).
export default {
    name: "CompetitiveProcessPicker",
    props: {
        value: { type: Number, default: null },
    },
    data: () => ({ processes: [], loading: false }),
    async created() {
        this.loading = true;
        try {
            const result = await axios.get(`${API}/processes`);
            this.processes = result.data.content;
            this.$emit("loaded", this.processes);
            if (!this.value || !this.processes.some((item) => item.id === this.value)) {
                const remembered = rememberedProcess();
                const fallback = this.processes.find((item) => item.id === remembered) || this.processes[0];
                if (fallback) this.select(fallback.id);
            }
        } catch (error) {
            notifyError(this, error);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        select(id) {
            rememberProcess(id);
            this.$emit("input", id || null);
            this.$emit("process", this.processes.find((item) => item.id === id) || null);
        },
    },
};
</script>
